<template>
  <a-form v-bind="$attrs" v-on="$listeners" :form="form" @submit="handleSearch">
    <slot name="time">
      <template v-if="timeShow">
        <a-form-item>
          <a-date-picker
            :initialValue="moment(new Date())"
            :format="dateFormat"
            :disabled-date="startDateDisabledDate"
            @change="startDateChange"
            v-decorator="['startDate']" style="vertical-align: middle;width:150px;margin-right:10px" />
        </a-form-item>
        <a-form-item>
          <a-date-picker
            v-decorator="['endDate']"
            :disabled-date="disabledDate"
            :initialValue="moment(new Date())" :format="dateFormat"
            style="vertical-align: middle;width:150px;margin-right:10px" />
        </a-form-item>
      </template>
    </slot>
    <slot></slot>
    <slot name="submit">
      <a-form-item>
        <a-button type="primary" html-type="submit" >查询
        </a-button>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" ghost @click="resetFields">清空
        </a-button>
      </a-form-item>
    </slot>
  </a-form>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: "formSkeletonForm" }),
      dateFormat: this.$root.$data.dateFormat,
      startDate: undefined // 关联 disabledDate
    };
  },
  props: {
    timeShow: false
  },
  methods: {
    moment,

    handleSearch(e) {
      e.preventDefault();
      this.form.validateFields((error, values) => {
        this.$emit('skeleton-submit', values);
      });
    },

    resetFields() {
      this.form.resetFields();
      // this.$emit("handle-submit", {});
    },
    disabledDate(endValue) {
      const startValue = this.startDate;
      if (!startValue) {
        return endValue.valueOf() > moment();
      }
      // 如果有开始时间  结束时间不能大于开始时间和当天
      return endValue.valueOf() < moment(this.startDate).valueOf() || endValue.valueOf() > moment();
    },
    startDateDisabledDate(current) {
      // Can not select days before today and today
      return current && current > moment();
    },
    startDateChange(val) {
      this.startDate = moment(val).format(this.dateFormat);
      this.form.setFieldsValue({
        endDate: undefined
      });
    }
  }
};
</script>

<style scoped>

</style>
